<script>
export default {
  methods: {
    search() {
      this.$emit('search');
    },
    cancel() {
      this.showFilters = false;
      this.$emit('cancel');
    },
  },
  data() {
    return {
      showFilters: false,
    };
  },
};
</script>

<template>
  <b-card
    no-body
    class="mt-2 mb-2 custom-inventory-shadow"
    style="user-select: none"
  >
    <div
      style="cursor: pointer; padding: 10px 12px 4px 12px; margin-bottom: 6px"
      @click="showFilters = !showFilters"
    >
      <i
        style="font-size: 1.4em; cursor: pointer"
        class="fas fa-angle-down toggleUpDown"
        :class="{ rotate: showFilters }"
      ></i>
      <span style="font-weight: 500" class="ml-2">{{
        $t('general.filters')
      }}</span>
    </div>

    <b-collapse v-model="showFilters">
      <b-container fluid v-show="showFilters">
        <slot name="row"></slot>
        <b-row style="padding-bottom: 12px">
          <b-col>
            <b-button variant="primary" size="sm" class="mr-2" @click="search">
              {{ $t('general.search') }}
            </b-button>
            <b-button variant="secondary" size="sm" @click="cancel">
              {{ $t('general.cancel') }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-collapse>
  </b-card>
</template>